import { useSession } from '@/hooks/useSession';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/auth/logout')({
	component: RouteComponent,
});

function RouteComponent() {
	const { isLoading, isAuthed, isDemo, signOut, hydrated } = useSession();

	const navigate = useNavigate();

	useEffect(() => {
		if (!hydrated || isLoading) return;
		if (isAuthed && signOut && !isDemo) signOut();
		else navigate({ to: '/' });
	}, [hydrated, isAuthed]);
}
